// extracted by mini-css-extract-plugin
module.exports = {"glsMapWidget":"gls_glsMapWidget__vG6tR","selected":"gls_selected__oS5_e","error":"gls_error__1OKsK"};